
import User from '@/views/user'
import ListUser from '@/views/user/list'
import CreateUser from '@/views/user/create'
import EditUser from '@/views/user/edit'

export default {
  path: 'user',
  redirect: '/user/list',
  name: 'User',
  component: User,
  children: [
    {
      path: 'list',
      name: 'User list',
      component: ListUser
    },
    {
      path: 'create',
      name: 'Create',
      component: CreateUser
    },
    {
      path: ':user_id/edit',
      name: 'Edit',
      component: EditUser
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/users/user.js